export const DELETE_METHOD_SINGLE = 'single';
export const DELETE_METHOD_WITH_SUBTASKS = 'with-subtasks';
